<template>
 
    
  <BlockUI v-if="submitLoader" :url="url"></BlockUI>
  <div v-else-if="!submitLoader">
      <div>
        <!-- <p class="martop20 h1 marbottom10">Welcome {{firstName}} {{lastName}},</p> -->
        <h1 class="otp-summary-title">Let's build your security profile</h1>
        <p class="otp-summary-description">
        Your security profile is used to identify you and help you recover forgotten credentials when needed.
        </p>
        <!-- <MessagesComponent></MessagesComponent> -->
        <!-- <hr class="marbottom10 mt-0" style="height:2px" />
        <h3 class="para1 marbottom20" style="display: inline-block;font-size: 18px;">Review your one-time passcode delivery option(s)</h3>
        <p class="para2 marbottom30" v-if="otpDeviceList.otpDeviceList.length==5">
        You have set up the maximum number of one-time passcode options allowed.
        </p>
        <p class="para2 marbottom30" v-if="otpDeviceList.otpDeviceList.length<=4">
        Your email address, mobile or landline phone number can be added to your profile to receive one-time passcode(OTP).
         You may have up to five delivery options. Delivery options can also be managed in 'MyProfile' settings later.
        </p> -->
        <div class="vbg-rsp-title-container">
        <p class="otp-summary-second-title">{{ $t("message.otp_summary_title") }}</p>
      </div>
      <div class="otp-summary-description-text">
        <p>
          {{ $t("message.reset_security_profile_otp_summary_description") }}
        </p>
      </div>
      <!-- <hr class="hr-bar hr-pos-24" /> -->
      <div class="ovrview-msg" v-if="isButtonDisabled">
        <div class="vbg-ff-messagesInfo" v-bind:class="'information'">
          <div class="vbg-ff-msg-container">
            <div class="messageWrapper">
              <div class="messageIcon msg-icon-position">
                <div class="messageImage" :class="'informationMessageImage'"></div>
              </div>
              <p v-if="smbMaxDevice" class="messageContentUn" v-html="max_devices_smb_limit_msg">
              <p v-if="!smbMaxDevice" class="messageContentUn" v-html="max_devices_limit_msg">
              </p>
            </div>
          </div>
        </div>
      </div>
        <div class="vbg-rsp-devices-table">
        <table class="view-otp-table">
          <thead class="table-head">
            <tr>
              <td>Delivery method</td>
              <td v-if="otpDeviceList.otpDeviceList.length != 1">Actions</td>
            </tr>
          </thead>

          <tbody class="table-body">
            <tr :class="[otpDeviceList.otpDeviceList.length - 1 == name ? 'table-body' : '']"
              v-for="(value, name) in otpDeviceList.otpDeviceList" :key="name">
              <td v-if="value.otp_type.toLowerCase() == 'email'">Email <span class="otp_device_text">{{ value.otp_value
              }}</span></td>
              <td v-if="value.otp_type.toLowerCase() == 'sms'">Text <span class="otp_device_text">{{ value.otp_value
              }}</span></td>
              <td v-if="value.otp_type.toLowerCase() == 'ivr'">Call <span class="otp_device_text">{{ value.otp_value
              }}</span></td>
              <td>
                <a @click="deleteDevice(value)" class="vbg-rsp-device-table-delete-icon"
                  v-if="otpDeviceList.otpDeviceList.length != 1" id="otpsum_delete" name="otpsum_delete"><img class="delete-icon-size"
                    src="@/common/assets/styles/corp/images/delete_bin.png" /></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
      <div id="modal-popup" class="modal fade">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <h3 class="mt-0">Are you sure you want to delete?</h3>
            <a
              data-dismiss="modal"
              class="pull-right close-icon-popup"
              style="padding: 0px;  cursor: pointer;"
            ></a>
            <p class="spacing05">You are about to delete {{ deviceToBeDelete }} as a verification delivery method.</p>
            <div class="modal-popup-btn-box">
            <button
              type="submit" data-dismiss="modal"
              id="confirm_del"
              name="confirm_del"
              class="btn vbg-ff-btn-continue modal-popup-btn vbg-ff-btn-width140 spacing05"
              @click="conformDeleteDevice()"
            >
              <span>Delete</span>
            </button>
            <button class="btn vbg-ff-btn-cancel modal-popup-btn vbg-ff-btn-width140 spacing05" data-dismiss="modal" id="otpsum_cancel" name="otpsum_cancel">
              <span>Cancel</span>
            </button>
          </div>
          </div>
        </div>
      </div>
    <div class="btn-reverse-mobile">
      <button
        type="submit"
        class="btn vbg-ff-btn-continue continue_btn vbg-ff-btn-width140 spacing05"
        :disabled="smbMaxDevice"
        @click="continueLogin()"
        id="otpsum_continue"
      >
        <span>Continue</span>
      </button>
      <!-- <router-link
        to="/profile/preauth/addotpdevice" @click="testmethod"
        :disabled="isButtonDisabled"
        :class="{ 'disabled' : isButtonDisabled }" 
        tag="button"
        id="addanotherdeliveryoption"
        class="btn vbg-ff-btn-cancel add-delivery-method-btn vbg-ff-btn-width140 spacing05"
      >
        <span>Add delivery method</span>
      </router-link> -->
      <button 
      @click="showAddDelivery()" 
      type="button"
      id="addanotherdeliveryoption"
      name="addanotherdeliveryoption"
      :disabled="isButtonDisabled"
      :class="{ 'disabled' : isButtonDisabled }" 
      class="btn vbg-ff-btn-cancel add-delivery-method-btn vbg-ff-btn-width140 spacing05"
    >
      <span>Add delivery method</span>
    </button>
      </div>
  </div>
    
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import MessagesComponent from "@/profile/components/core/MessagesComponent";
import $ from "jquery";
import {setPageDetails,eventTracking,errorSet} from '../../../../public/adobeTagging';
import translations from "@/common/assets/json/messages1.json";
import commonMixin from "@/common/mixin/commonMixins";
export default {
  name: "OTPSummaryComponent",
  data() {
    return {
      //url: iamvar_cdnUrl + iamvar_imgSourceContext +'/business/login/includes/img/circle-loaderWHITE_48x48.d05e483d.gif',
      //url : loadingImage,
                  url: iamvar_cdnUrl + iamvar_imgSourceContext +'/business/login/includes/circle-loaderWHITE_48x48.gif',
      newpassword: "",
      currentPassword: "",
      confirmpassword: "",
      modalShow: false,
      delSelectedDevice: "",
      deviceToBeDelete:"",
      max_devices_limit_msg: translations.en.message['reset_security_profile_otp_summary_max_devices'],
      max_devices_smb_limit_msg: translations.en.message['smb_max_device_summary'],
    };
  },
  mixins: [commonMixin],
  async created() {
    setPageDetails('OTP:OTP Overview page'); 
  },
  components: {
    // MessagesComponent
    },
  methods: {
    continueLogin() {
      let payload = {
        uuID: this.uuID,
      };
      this.callRedirectURL(payload);
    },
    ...mapActions("profile", [
      "getOtpDeviceList",
      "deleteOTPDevice",
      "callRedirectURL",
      "resetMessages",
    ]),
    async onSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
       
      }
      return;
    },
    cancel() {
      this.$router.push({ path: "overview" });
    },
    showAddDelivery() {
      this.resetMessages();
      this.$router.push({ path: "/profile/preauth/addotpdevice" });
    },
    deleteDevice(item) {
      this.deviceToBeDelete=item.otp_value;
      this.delSelectedDevice = item.guid;
      $("#modal-popup").modal({
        backdrop: "static",
      });
    },
      
    conformDeleteDevice() {
      let payload = {
        uuID: this.uuID,
        otpDeviceList: [
          {
            guid: this.delSelectedDevice,
            otp_type: this.deviceToBeDelete
          },
        ],
      };

      this.deleteOTPDevice(payload);
    },
    cancel() {
      this.resetMessages();
      this.$router.push({ path: "overview" });
    },
    moveover() {
      $("#Pc1Info").popover({ trigger: "hover focus" });
    },
  },
  computed: {
    ...mapGetters("profile", [
      "otpDeviceList",
      "uuID",
      "errorMsg",
      "showerrorMsg",
      "infoMsg",
      "showinfoMsg",
      "redirectUrl",
      "submitLoader",
      "changeURL",
      "firstName",
      "lastName",
      "showProcessLoader",
      "gotoOtp",
      "smbMaxDevice",
    ]),
    isButtonDisabled() {
      if(this.otpDeviceList && this.otpDeviceList.otpDeviceList){
        return this.otpDeviceList.otpDeviceList.length == 5;
      } else {
        return false
      }
        
    },
  },
  mounted() {
    this.changeContextBiocatch('preauth_otpsummary_page')
  },
  watch: {
     gotoOtp: function (newVal) {
        if (newVal) {
          this.$router.push({ path: 'addotpdevice' })
        }
      },
    showProcessLoader: function (newVal) {
      if (newVal === true) {
        this.$router.push({ path: "redirecting" });
     
    }
    },
  },
 
};
</script>

<style scoped>
.otp-summary-title{
  margin-bottom: 12px;
}
.otp-summary-description{
  margin-bottom: 48px;
}
.otp-summary-second-title{
  color: #000000;
  font-family: VzNHGeDS-bold11;
  font-size: 20px;
}
.devices-table {
  width: 596px;
}
table { border-collapse: collapse; border-spacing: 0; }

.otp_device_text {
  margin-left: 8px;
}

.vbg-rsp-device-table-delete-icon {
  margin-left: 10px;
}

.otp-summary-description-text {
  padding-bottom: 32px;
}
.continue_btn {
  margin-top: 48px;
  margin-right: 12px;
}

.add-delivery-method-btn {
  margin-top: 48px;
}
.ovrview-msg {
  padding-bottom: 24px;
  max-width: 914px;
}
.msg-icon-position {
  padding: 0px;
  margin-right: 12px;
}
.messageContentUn {
  font-size: 16px;
  /* font-weight: bold; */
  letter-spacing: 0.5px;
  line-height: 20px;
  padding: 0px;
  margin: 0px;
  color: #ffffff
}

#modal-popup {
  width: 100% !important;
  position: absolute !important;
}

.modal-dialog {
  width: 560px;
  height: 308px;
  margin: 0 auto !important;
  position: relative;
  top: 33%;
}

.modal-content {
  width: 560px;
  height: 308px;
  padding: 48px !important;
}

#modal-popup h3 {
  margin-bottom: 24px;
}

#modal-popup p {
  margin-bottom: 72px;
}

a.disabled {
  pointer-events: none;
  cursor: default;
  color: grey;
}


@media (min-width: 280px) and (max-width: 768px) {
  .modal-dialog{
    width: 100%;
    height: 100%;
  }
  .modal-content{
    width: 100%;
    height: 100%;
  }
  .modal-dialog {
    top: 0;
  }
  .continue_btn {
    margin-top: 12px;
    margin-bottom: 64px !important;
  }
  .btn-reverse-mobile {
    display: flex;
    flex-direction: column-reverse;
  }
}

@media (min-width: 768px) {
  .modal-popup-btn {
    height: 44px !important;
    line-height: 18px;
    font-size: 16px;
    padding: 12px;
    text-align: center;
  }
}
@media (min-width: 1025px) {
  .continue_btn {
  width: 220px;
  }
  .add-delivery-method-btn {
    width: 220px;
  }
}
@media (max-width: 320px) {
  .messageWrapper {
    display: flex;
  }
}
@media (max-width: 425px) {

.messageContent,
.messageContentUn {
  width: 232px;
}
}

@media (max-width: 482px) {
  .msg-icon-position {
    padding-bottom: 60px !important;
  }
}

</style>
